import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26cc9026"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "message"
}

import { computed } from "vue";

const pagesToDisplay = 3;


export default /*#__PURE__*/_defineComponent({
  __name: 'ListPagination',
  props: {
  totalItems: {
    type: Number,
    default: 0,
  },
  pageSize: {
    type: Number,
    default: 10,
  },
  totalPages: {
    type: Number,
    default: 0,
  },
  hasPrevious: {
    type: Boolean,
    default: false,
  },
  hasNext: {
    type: Boolean,
    default: false,
  },
  currentPage: {
    type: Number,
    default: 5,
  },
},
  emits: ["changePage"],
  setup(__props, { emit }) {

const props = __props;



const startPage = computed(() => {
  if (props.currentPage >= pagesToDisplay) {
    const pagesToAdd = Math.floor(pagesToDisplay / 2);
    const newMaxPage = pagesToAdd + props.currentPage;
    if (newMaxPage > props.totalPages) {
      return props.totalPages - pagesToDisplay + 1;
    }
    return props.currentPage - pagesToAdd;
  } else {
    return 1;
  }
});
const endPage = computed(() => {
  if (props.currentPage >= pagesToDisplay) {
    const pagesToAdd = Math.floor(pagesToDisplay / 2);
    const newMaxPage = pagesToAdd + props.currentPage;

    if (newMaxPage < props.totalPages) {
      return newMaxPage;
    } else {
      return props.totalPages;
    }
  } else {
    return props.totalPages < pagesToDisplay
      ? props.totalPages
      : pagesToDisplay;
  }
});

const changePage = (newPage) => {
  if (newPage != props.currentPage) {
    emit("changePage", newPage);
  }
};

const range = (min, max) => {
  let arr = [];
  for (let i = min; i <= max; i++) {
    arr.push(i);
  }
  return arr;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.totalItems > 0)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(range(startPage.value, endPage.value), (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item,
                class: _normalizeClass({ active: __props.currentPage === item })
              }, [
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  onClick: ($event: any) => (changePage(item))
                }, _toDisplayString(item), 9, _hoisted_3)
              ], 2))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("pagination.empty")), 1))
  ]))
}
}

})